export enum NotificationType {
  ZendeskTicketWasChanged = 'zendeskTicketWasChanged',
  ZendeskTicketFieldWasChanged = 'zendeskTicketFieldWasChanged',
}
